'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functions = require('../functions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FlagIcon = function FlagIcon(React, options) {
  return function (_ref) {
    var props = _objectWithoutProperties(_ref, []),
        _ref$Component = _ref.Component,
        Component = _ref$Component === undefined ? 'span' : _ref$Component,
        children = _ref.children;

    var stylePropName = options.useCssModules ? 'styleName' : 'className';
    var p = _defineProperty({}, stylePropName, (0, _functions.makeClassnames)(props, options));

    return React.createElement(
      Component,
      p,
      children
    );
  };
};

exports.default = FlagIcon;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/FlagIcon/FlagIcon.js
// module id = 798
// module chunks = 0